import { useEffect } from "react";
import { useIntl } from "react-intl";
import { setIntl } from "../utils/intl";

export const IntlInitializer = ({ children }) => {
  const intl = useIntl();

  useEffect(() => {
    setIntl(intl);
  }, [intl]);

  return children;
};
